
export default {
    name: 'rapport-toutes-depenses',
    components: {},
    props: {
        rapport_toutes_depenses: Array,
        modal_toggler: Number
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, { key: 'montant', label: 'Montant' }, 
                'preuve'
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            depense_len: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.refreshAllDepense()
        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {
        refreshAllDepense() {
            if (this.rapport_toutes_depenses) {
                this.depense_len = this.rapport_toutes_depenses.length
            }
        }
    }
}